import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@progress/kendo-react-buttons";
import "./SignOutButton.scss";

const SignOutButton = () => {
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/",
        });
        sessionStorage.clear();
    }


    return (
        <Button className={"signOutButton"} fillMode={"link"} onClick={() => handleLogout()}>
            <span className="k-icon k-i-logout">&nbsp;</span>Logout
        </Button>
    );
};

export default SignOutButton